import * as React from 'react';

export interface ITableColumn<T> {
  key: string;
  header: string;
  width?: number; // %
  widthPx?: number; // px
  cell: (rowData: T) => React.ReactElement;
}

export interface ITableConfig<T> {
  getRowId: (rowData: T) => string;
}

export interface ITableProps<T> {
  columnConfigs: ITableColumn<T>[];
  data: T[];
  tableConfig: ITableConfig<T>;
}

const getColumnWidth = (percentageWidth: number, pixelWidth: number): string => {
  if (!percentageWidth && !pixelWidth) {
    return null;
  }
  if (percentageWidth) {
    return `${percentageWidth}%`;
  }
  return `${pixelWidth}px`;
};

export const Table = <T extends Object>({ columnConfigs, data, tableConfig }: ITableProps<T>) => {
  return (
    <div className='app-table'>
      <table>
        <thead>
          <tr>
            {columnConfigs.map(column => (
              <th key={column.key} style={{ width: getColumnWidth(column.width, column.widthPx) }}>
                {column.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map(row => {
            const rowId = tableConfig.getRowId(row);
            return (
              <tr key={rowId}>
                {columnConfigs.map(column => (
                  <td key={`${rowId}-${column.key}`}>{column.cell(row)}</td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
